import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { SelectItem } from 'primeng/api';

import { CoachSettingsGeneralSectorsController } from './coach-settings-general-sectors.controller';

@Component({
	selector: 'spr-coach-settings-general-sectors',
	templateUrl: './coach-settings-general-sectors.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachSettingsGeneralSectorsController],
	host: {
		class: 'h-full',
	},
})
export class CoachSettingsGeneralSectorsComponent {
	public sectorOptions$: Observable<SelectItem[]>;

	@Input() public sectorsForm: FormGroup;

	constructor(private _controller: CoachSettingsGeneralSectorsController) {
		this.sectorOptions$ = _controller.sectorOptions$;
	}
}
